import { AccessibleIcon } from "@offstreetparking/design-system/accessibility";
import type { ForwardRefExoticComponent, RefAttributes, SVGProps } from "react";

export const ParkingDetailsRow = ({
	children,
	iconLabel,
	icon: Icon,
}: {
	children: React.ReactNode;
	iconLabel?: string;
	icon: ForwardRefExoticComponent<
		Omit<SVGProps<SVGSVGElement>, "ref"> & {
			title?: string | undefined;
			titleId?: string | undefined;
		} & RefAttributes<SVGSVGElement>
	>;
}) => {
	return (
		<div className="flex gap-4 text-neutral">
			<AccessibleIcon label={iconLabel}>
				<Icon className="mt-0.5 h-5 min-h-5 w-5 min-w-5" />
			</AccessibleIcon>
			{children}
		</div>
	);
};
